<template>
  <div id="app" class="landing-vx-layout">
    <div class="landing-vx-header">
      <div class="vx-nav-wrapper">
        <div class="vx-c-hd">
          <div class="vx-fl-wrap display-flex justify-between">
            <div class="vx-fl-l display-flex">
              <a href="#top" class="vx-nav-brand">
                <img loading="lazy" alt="SolCactus" class="vx-nav-img" src="logo.png">
              </a>
              <nav class="vx-navigation display-flex items-center" role="navigation">
                <div class="vx-max display-flex items-center">
                  <div class="vx-nav-divide"></div>
                  <a href="#attrs" class="vx-nav-link l-res vx-attrs">Attributes</a>
                  <a href="#roadmap" class="vx-nav-link l-res vx-road">Roadmap</a>
                  <a href="#royalty" class="vx-nav-link l-res vx-faq">Royalty</a>
                  <a href="#faq" class="vx-nav-link l-res vx-faq">FAQ</a>                  
                </div>
                <div class="vx-bp-md">
                  <button class="vx-md-btn">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect y="2" width="22" height="3" fill="black"/>
                      <rect y="9" width="22" height="3" fill="black"/>
                      <rect y="16" width="22" height="3" fill="black"/>
                    </svg>
                  </button>
                </div>
              </nav>
            </div>
            <div class="vx-fl-r display-flex items-center">
              <div class="vx-socials display-flex">
                <a href="https://twitter.com/SolanaCactus" class="vx-s-btn">
                  <svg class="vx-svg-tw" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.7386 6.519C19.7525 6.71442 19.7525 6.90989 19.7525 7.10531C19.7525 13.0659 15.2157 19.934 6.92386 19.934C4.36928 19.934 1.9962 19.1941 0 17.9099C0.362957 17.9517 0.711906 17.9657 1.08883 17.9657C3.19666 17.9657 5.13704 17.2538 6.68654 16.0393C4.7043 15.9974 3.04313 14.6992 2.47079 12.9124C2.75 12.9543 3.02917 12.9822 3.32234 12.9822C3.72715 12.9822 4.132 12.9263 4.50888 12.8287C2.4429 12.4098 0.893363 10.5951 0.893363 8.40353V8.34771C1.49359 8.68274 2.19162 8.89212 2.93141 8.92001C1.71695 8.11035 0.921293 6.72839 0.921293 5.16493C0.921293 4.32738 1.1446 3.55962 1.53549 2.88956C3.75504 5.6256 7.09135 7.41237 10.8324 7.60783C10.7626 7.2728 10.7207 6.92385 10.7207 6.57486C10.7207 4.09007 12.7309 2.06598 15.2296 2.06598C16.5278 2.06598 17.7004 2.61039 18.524 3.48983C19.543 3.29441 20.5202 2.91749 21.3857 2.40101C21.0506 3.44798 20.3387 4.32742 19.4035 4.88576C20.3109 4.78809 21.1903 4.53677 21.9999 4.18782C21.3858 5.08118 20.618 5.87683 19.7386 6.519V6.519Z" fill="white"/>
                  </svg>
                </a>
                <a href="https://discord.gg/QCMUd6THUU" class="vx-s-btn">
                  <svg class="vx-svg-ds" width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.0308 2.45519C18.0252 2.44406 18.0159 2.43534 18.0045 2.43058C16.694 1.81565 15.3111 1.37716 13.8903 1.12608C13.8774 1.12362 13.8641 1.12539 13.8522 1.13114C13.8403 1.13688 13.8306 1.1463 13.8242 1.15807C13.6359 1.50762 13.465 1.86667 13.312 2.23385C11.7805 1.99608 10.2227 1.99608 8.69114 2.23385C8.5372 1.86574 8.36352 1.5066 8.17088 1.15807C8.16427 1.14656 8.15443 1.13735 8.14263 1.13165C8.13084 1.12594 8.11763 1.124 8.10474 1.12608C6.68381 1.37663 5.30078 1.81516 3.99047 2.43062C3.97925 2.43548 3.96978 2.44379 3.96338 2.45438C1.34301 6.4565 0.625188 10.3602 0.977325 14.2156C0.978316 14.225 0.981154 14.2342 0.985672 14.2425C0.99019 14.2508 0.996294 14.2581 1.00362 14.2639C2.52944 15.4194 4.23609 16.3013 6.05073 16.8721C6.06351 16.8761 6.07716 16.8759 6.08984 16.8716C6.10251 16.8674 6.11361 16.8593 6.12165 16.8484C6.51139 16.306 6.85674 15.7317 7.15417 15.1313C7.15826 15.123 7.16059 15.114 7.16102 15.1048C7.16144 15.0955 7.15995 15.0863 7.15664 15.0777C7.15333 15.0691 7.14828 15.0614 7.14182 15.0549C7.13535 15.0484 7.12762 15.0435 7.11914 15.0403C6.57456 14.8272 6.04734 14.5703 5.54243 14.272C5.53326 14.2665 5.52555 14.2588 5.52 14.2495C5.51445 14.2402 5.51121 14.2297 5.51058 14.2188C5.50995 14.2079 5.51195 14.1971 5.5164 14.1872C5.52084 14.1773 5.5276 14.1687 5.53607 14.1621C5.64201 14.0809 5.74803 13.9965 5.84919 13.9112C5.85818 13.9036 5.86905 13.8988 5.88059 13.8972C5.89213 13.8956 5.90388 13.8973 5.9145 13.9022C9.22238 15.4462 12.8036 15.4462 16.0723 13.9022C16.083 13.897 16.0948 13.8951 16.1065 13.8965C16.1183 13.898 16.1293 13.9028 16.1385 13.9104C16.2397 13.9957 16.3456 14.0809 16.4524 14.1621C16.4609 14.1686 16.4677 14.1772 16.4722 14.187C16.4767 14.1969 16.4788 14.2077 16.4783 14.2186C16.4777 14.2295 16.4745 14.24 16.4691 14.2493C16.4636 14.2586 16.4559 14.2664 16.4468 14.272C15.943 14.5728 15.4153 14.8295 14.8693 15.0395C14.8608 15.0428 14.8531 15.0479 14.8467 15.0544C14.8403 15.061 14.8353 15.0688 14.8321 15.0775C14.8288 15.0862 14.8274 15.0954 14.8279 15.1047C14.8284 15.114 14.8308 15.123 14.835 15.1313C15.1374 15.7284 15.4822 16.3019 15.8667 16.8474C15.8745 16.8586 15.8855 16.867 15.8983 16.8714C15.911 16.8758 15.9247 16.8761 15.9376 16.872C17.7555 16.3031 19.4651 15.4211 20.9929 14.2639C21.0003 14.2584 21.0065 14.2513 21.011 14.2431C21.0156 14.2349 21.0183 14.2258 21.0192 14.2164C21.4407 9.75919 20.3134 5.88746 18.0308 2.45519ZM7.64817 11.8681C6.65226 11.8681 5.83166 10.9334 5.83166 9.78545C5.83166 8.63752 6.63634 7.70276 7.64817 7.70276C8.66791 7.70276 9.48057 8.64565 9.46465 9.78538C9.46465 10.9334 8.65993 11.8681 7.64817 11.8681ZM14.3644 11.8681C13.3685 11.8681 12.5479 10.9334 12.5479 9.78545C12.5479 8.63752 13.3526 7.70276 14.3644 7.70276C15.3842 7.70276 16.1968 8.64565 16.1809 9.78538C16.1809 10.9334 15.3842 11.8681 14.3644 11.8681Z" fill="white"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-nav-md vx-b-rounded">
        <a href="#attrs" class="vx-nav-link-md l-res vx-attrs">Attributes</a>
        <a href="#roadmap" class="vx-nav-link-md l-res vx-road">Roadmap</a>
        <a href="#faq" class="vx-nav-link-md l-res vx-faq">FAQ</a>
      </div>
    </div>
    <div class="landing-vx-container">
      <section class="landing-vx-section vx-ld-first" id="top">
        <div class="vx-s-wrap s-h-462 s-mw-641 vx-s-flex-ic">
          <div class="vx-s-inner">
            <h1 class="vx-tf vx-h1 vx-f-b vx-title">Introducing Solana Cactus!</h1>
            <p class="vx-p-alt"><span class="vx-f-b">Limited:</span> 2,222 unique, green, algorithmically generated Cactus - stored with proof of ownership stored on the Solana blockchain.</p>
          </div>
        </div>
        <div class="vx-s-wrap vx-s-flex-ic">
          <div class="vx-s-inner">
            <h2 class="vx-tf vx-h2 vx-f-b vx-title">About Cactus</h2>
            <div class="vx-s-pic-flex">
              <img class="vx-img-s vx-b-rounded" src="s2-cactus.png" loading="lazy" alt="Cactus">
              <div class="vx-s-p-wrap">
                <p class="vx-p-alt vx-p-s-mb"><span class="vx-f-b">Limited:</span> 2,222 unique, green, algorithmically generated Cactus - stored with proof of ownership stored on the Solana blockchain.</p>
                <p class="vx-p-alt">We believe that SF is more than just pictures. We think that in the future it will become part of the culture. What could be better than becoming a part of something beautiful?</p>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-bg-container"></div>
      </section>
      <section class="landing-vx-section vx-ld-second vx-bg-vsc vx-b-rounded-s" id="attrs">
        <div class="vx-s-wrap s-mw-641 vx-s-flex-ic">
          <div class="vx-s-inner">
            <h2 class="vx-tf vx-h2 vx-f-b vx-title-mb-2xl">2 222 algorithmically generated from 50+ attributes</h2>
            <p class="vx-p-alt">Each attribute has a certain rarity.</p>
          </div>
        </div>
      </section>
      <section class="landing-vx-section vx-ld-third vx-bg-vtc vx-b-rounded-s" id="roadmap">
        <div class="vx-s-wrap vx-s-flex-ic vx-fs-0">
          <div class="vx-s-inner">
            <h2 class="vx-tf vx-h2 vx-f-b vx-title">Our roadmap</h2>
            <div class="vx-phase">
              <p class="vx-p-alt vx-f-b vx-ph-mb">Phase 1</p>
              <p class="vx-p-alt">1. Build a community</p>
              <p class="vx-p-alt">2. Pre-Launch raffles</p>
              <p class="vx-p-alt">3. Website development</p>
              <p class="vx-p-alt">4. Launch Discord & Twitter</p>
              <p class="vx-p-alt">5. Giveaway 22 SolCactus for community</p>
            </div>
            <div class="vx-phase">
              <p class="vx-p-alt vx-f-b vx-ph-mb">Phase 2</p>
              <p class="vx-p-alt">1. Add rarity</p>
              <p class="vx-p-alt">2. Website release</p>
              <p class="vx-p-alt">3. Whitelist mint 300 SolCactus NFTs</p>
              <p class="vx-p-alt">4. Mint 1900 SolCactus NFTs</p>
              <p class="vx-p-alt">5. Listing on popular marketplaces</p>
              <p class="vx-p-alt">6. Part of royalties will spend to raise floor</p>
            </div>
            <div class="vx-phase">
              <p class="vx-p-alt vx-f-b vx-ph-mb">Phase 3</p>
              <p class="vx-p-alt">1. Donate part of the sale proceeds to Charity</p>
              <p class="vx-p-alt">2. Develop P2E NFT game</p>
              <p class="vx-p-alt">3. Launch game</p>
              <p class="vx-p-alt">4. Continue to innovate based on community requests</p>
            </div>
          </div>
        </div>
      </section>
      <section class="landing-vx-section vx-ld-fourth vx-bg-vfc t-col-w vx-b-rounded-s" id="royalty">
        <div class="vx-s-wrap s-mw-641 vx-s-flex-ic">
          <div class="vx-s-inner">
            <h2 class="vx-tf vx-h2 vx-f-b vx-title-mb-2xl">Royalty</h2>
            <p class="vx-p-alt">50% of sales on the secondary market will be divided between the holders of SolCactus.</p>
          </div>
        </div>
      </section>
      <section class="landing-vx-section vx-ld-fifth vx-bg-v5c vx-ld-last vx-b-rounded-s" id="faq">
        <div class="vx-s-wrap vx-s-flex-ic">
          <div class="vx-s-inner">
            <h2 class="vx-tf vx-h2 vx-f-b vx-title-mb-2xl">FAQ</h2>
            <p class="vx-p-alt">There may be frequently asked questions about our project here.</p>
            <div class="vx-accordion">
              <div class="vx-accordion-collapse collapse">
                <div class="vx-accordion-collapse-btn collapse-btn">
                  <div class="vx-accordion-title display-flex items-center">
                    <img class="vx-accordion-img" alt src="faq-sb.png">
                    <p class="vx-p-alt vx-f-b">What are Solana Cactus?</p>
                  </div>
                  <div class="vx-accordion-arrow display-flex items-center">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.6875 8.625L11.5 15.8125L4.3125 8.625" stroke="black" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                <div class="vx-accordion-content collapse-content">
                  <p class="vx-p-alt vx-accordion-alt">2,222 unique, green, algorithmically generated Cactus - stored with proof of ownership stored on the Solana blockchain.</p>
                </div>
              </div>
              <div class="vx-accordion-collapse collapse">
                <div class="vx-accordion-collapse-btn collapse-btn">
                  <div class="vx-accordion-title display-flex items-center">
                    <img class="vx-accordion-img" alt src="faq-sb.png">
                    <p class="vx-p-alt vx-f-b">What is the total supply?</p>
                  </div>
                  <div class="vx-accordion-arrow display-flex items-center">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.6875 8.625L11.5 15.8125L4.3125 8.625" stroke="black" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                <div class="vx-accordion-content collapse-content">
                  <p class="vx-p-alt vx-accordion-alt">There will be 2,222 SolCactus minted from 50 attributes - every Cactus will be unique. 22 SolCactus are being kept for promotional purposes. There will never be more than 2,222 Solana Cactus.</p>
                </div>
              </div>
              <div class="vx-accordion-collapse collapse">
                <div class="vx-accordion-collapse-btn collapse-btn">
                  <div class="vx-accordion-title display-flex items-center">
                    <img class="vx-accordion-img" alt src="faq-sb.png">
                    <p class="vx-p-alt vx-f-b">How Much Will SolCactus NFT's Cost?</p>
                  </div>
                  <div class="vx-accordion-arrow display-flex items-center">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.6875 8.625L11.5 15.8125L4.3125 8.625" stroke="black" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
                <div class="vx-accordion-content collapse-content">
                  <p class="vx-p-alt vx-accordion-alt">1 SOL for public sale<br>
                    0.5 SOl for whitelist
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss" type="text/scss">
@import 'public/mixins';

.vx-ld-first{
  margin-top: 84px;
}

.landing-vx-layout{
  max-width: var(--vx-max-w);
  margin: 0 auto;
  max-height: 100%;
  padding: 0 var(--vx-space-xl);
}

.landing-vx-container{
  padding-bottom: var(--vx-space-3xl);
}

.landing-vx-header{
  position: fixed;
  top: var(--vx-space-xl);
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 1000;
  width: 100%;
  max-width: var(--vx-max-w);
  padding: 0 var(--vx-space-xl);
  height: 65px;
}

.vx-nav-wrapper{
  max-width: var(--vx-max-w);
  margin-right: auto;
  margin-left: auto;
  border: 1px solid #000;
  background-color: #fff;
  box-shadow: 3px 3px 0 0 rgb(0 0 0 / 40%);
  position: relative;
  padding: 0 var(--vx-space-m);
  border-radius: var(--vx-border-radius-m);
  .vx-fl-wrap{
    gap: var(--vx-space-s);
  }
}

.vx-nav-brand{
  padding: var(--vx-space-s) 0;
}

.vx-nav-img{
  max-height: var(--vx-size-custom-39);
}

.vx-max{
  gap: var(--vx-space-xl);
  margin-left: var(--vx-space-xl);
  padding: var(--vx-space-s) 0;
  .vx-nav-divide{
    width: var(--vx-size-5xs);
    height: var(--vx-size-custom-30);
    background-color: var(--vx-gray);
  }
  .vx-nav-link{
    font-weight: 700;
    transition: .2s;
    &:hover{
      color: var(--vx-nav-hover);
      transition: .2s;
    }
  }
  @include media("max", "md") {
    display: none;
  }
}

.vx-socials{
  gap: var(--vx-space-2xs);
  .vx-s-btn{
    @include flex;
    align-items: center;
    justify-content: center;
    background: var(--vx-black);
    color: var(--vx-white);
    width: var(--vx-size-custom-39);
    height: var(--vx-size-custom-39);
    transition: .2s;
    &:hover{
      transition: .2s;
      background: var(--vx-btn-hover);
    }
  }
}

.vx-navigation{
  .vx-bp-md{
    display: none;
    @include media("max", "md") {
      display: flex;
      margin-left: var(--vx-space-xl);
    }
  }
}

.vx-md-btn{
  cursor: pointer;
}

.vx-nav-md{
  border: 1px solid var(--vx-black);
  background-color: var(--vx-white);
  box-shadow: 3px 3px 0 0 rgb(0 0 0 / 40%);
  margin-top: 10px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: .2s;
  &.active{
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    transition: .2s;
  }
    .vx-nav-link-md{
    padding: 13px 12px 10px;
    font-weight: 700;
    transition: .2s;
    &:hover{
      color: var(--vx-nav-hover);
      transition: .2s;
    }
  }
}

.vx-s-wrap{
  &.vx-s-flex-ic{
    @include flex;
    align-items: center;
  }
  &.vx-s-flex-jc{
    @include flex;
    justify-content: center;
  }
  &.vx-s-flex-all{
    @include flex;
    justify-content: center;
    align-items: center;
  }
  &.s-h-462{
    height: 462px;
  }
  &.s-mw-641{
    max-width: 641px;
  }
}

.vx-title{
  margin-bottom: var(--vx-space-3xl);
  @include media("max", "md") {
    margin-bottom: var(--vx-space-2xl);
  }
}

.vx-title-mb-2xl{
  margin-bottom: var(--vx-space-2xl);
  @include media("max", "md") {
    margin-bottom: var(--vx-space-xl);
  }
}

.vx-p-s-mb{
  margin-bottom: var(--vx-space-xl);
}

.vx-s-pic-flex{
  @include flex;
  align-items: center;
  gap: var(--vx-space-4xl);
  .vx-img-s{
    width: 100%;
    max-width: 250px;
  }
  @include media("max", "lg") {
    flex-direction: column;
    align-items: start;
  }
}

.vx-bg-vsc{
  background: var(--vx-second-container);
  background-image: url("../public/vx-s-bg-2.png");
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
}

.vx-bg-vtc{
  background: var(--vx-third-container);
}

.vx-bg-vfc{
  background: var(--vx-fourth-container);
}

.vx-bg-v5c{
  background: var(--vx-fifth-container);
}

.vx-ld-first{
  margin-bottom: var(--vx-space-5xl);
}

.vx-ld-second, .vx-ld-third, .vx-ld-fourth, .vx-ld-fifth{
  padding: var(--vx-space-4xl) var(--vx-space-4xl);
  margin-bottom: var(--vx-space-2xl);
  @include media("max", "md") {
    padding: var(--vx-space-2xl) var(--vx-space-2xl);
  }
}

.vx-ph-mb{
  margin-bottom: var(--vx-space-m);
}

.vx-s-inner{
  width: 100%;
}

.vx-phase{
  margin-bottom: var(--vx-space-3xl);
  &:last-child{
    margin-bottom: 0;
  }
}

.vx-bg-container{
  position: absolute;
  left: auto;
  top: 0%;
  right: 0%;
  bottom: auto;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-image: url("../public/vx-section-bg.png");
  background-position: 100% 0%;
  background-size: 580px;
  background-repeat: no-repeat;
  @include media("max", "lg") {
    opacity: 0.3;
  }
  @include media("max", "md") {
    display: none;
  }
}

.vx-accordion-collapse-btn{
  @include flex;
  padding-top: var(--vx-space-l);
  padding-bottom: var(--vx-space-l);
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px solid var(--vx-black);
  cursor: pointer;
  .vx-accordion-arrow {
    transform: rotate(0deg);
    transition: 0.4s;
  }
  &.active{
    .vx-accordion-arrow{
      transform: rotate(180deg);
      transition: 0.4s;
    }
  }
}

.vx-accordion-alt{
  padding-top: var(--vx-space-l);
  padding-bottom: var(--vx-space-l);
}

.vx-accordion-content {
  max-height: 0;
  overflow: hidden;
  user-select: none;
  transition: max-height 0.2s ease-out;
}

.vx-accordion-img{
  width: var(--vx-size-3xl);
}

.vx-accordion-title{
  gap: var(--vx-size-xl);
}

</style>
